export default __webpack_public_path__ + "static/media/Annons 3.a648a2e5.jpg";